<template>
  <div>
    <h1 class="display-4">Notes de version</h1>
    <hr />

    <ul>
      <li><strong>0.0.11 &ndash; 22/10/2019</strong> : Ajout d'un effet visuel lors du filtrage, sélection des évenements par lot, ajout de l'adresse de l'événement par défaut si multiple campus.</li>
      <li><strong>0.0.10 &ndash; 17/10/2019</strong> : <a href="#" @click.prevent="changelog('0.0.10')">Cliquez pour lire le détail</a>.</li>
      <li><strong>0.0.9 &ndash; 26/08/2019</strong> : Amélioration du filtre.</li>
      <li><strong>0.0.8 &ndash; 26/08/2019</strong> : Suppression titre, amélioration ajout photo, correction duplication.</li>
      <li><strong>0.0.7 &ndash; 24/04/2019</strong> : Modification des vérifications des champs obligatoires.</li>
      <li><strong>0.0.6 &ndash; 13/03/2019</strong> : Duplication d'un événement par une ou plusieurs dates.</li>
      <li><strong>0.0.5 &ndash; 11/03/2019</strong> : Ajout des nouveaux champs pour un événement, upload des images et choix de celle-ci dans l'événement.</li>
      <li><strong>0.0.4 &ndash; 05/03/2019</strong> : Ajout de nouveaux champs pour un événement.</li>
      <li><strong>0.0.3 &ndash; 10/10/2018</strong> : Ajout du changement de mot de passe et du mot de passe oublié.</li>
      <li><strong>0.0.2 &ndash; 09/10/2018</strong> : Ajout des campagnes Salesforce et des messages flash.</li>
      <li><strong>0.0.1 &ndash; 05/10/2018</strong> : Ré-écriture de l'ancien EventDB "à l'identique".</li>
    </ul>

    <h2>TO-DO</h2>

    <ul>
      <li>Passage de Bootstrap à Bootsrap-vue.</li>
      <li>Suppression des messages flash par des toasts BV.</li>
      <li>Simplification du code pour les créations de campagnes sur SF.</li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    changelog (version) {
      let messages = []
      switch (version) {
        case '0.0.10':
          // message += '&bullet; fgjshndn'
          // let test = this.$createElement(
          //   'ul',
          //   null,
          //   [
          //     this.$createElement('li', 'sdfjkfjskdlgsdgkl'),
          //     this.$createElement('li', 'sdfjkfjskdlgsdgkl')
          //   ]
          // )
          messages = [
            this.$createElement('li', 'Affichage des filtres par défaut.'),
            this.$createElement('li', 'Ajout du filtre "Créateur d\'événement".'),
            this.$createElement('li', 'Ajout du filtre "Date de fin" qui permet de faire une recherche par période (libellé "Date de fin" à définir).'),
            this.$createElement('li', 'Liens cliquables dans le détail des événements.'),
            this.$createElement('li', 'Ajout d\'une vue agenda via un onglet.'),
            this.$createElement('li', 'Largeur de la saisie d\'un événement réduite.'),
            this.$createElement('li', 'Possibilité de supprimer un label.'),
            this.$createElement('li', 'Adresse du campus ajoutée par défaut + ajout du code postal.'),
            this.$createElement('li', 'Description comprise entre 40 et 500 caractères.'),
            this.$createElement('li', 'Ajout d\'une fenêtre de confirmation avant création d\'un événement.'),
            this.$createElement('li', 'Ajout d\'un message d\'information si l\'événement va dans Salesforce.'),
            this.$createElement('li', 'Ajout d\'un champ date afin de planifier l\'activation d\'un événement.'),
            this.$createElement('li', 'Possibilité de créer un utilisateur directement via EventDB.'),
            this.$createElement('li', 'Export des événements en CSV (à améliorer).')
          ]
          // message += test
          // message.push(test)
          break
      }

      let message = this.$createElement(
        'ul',
        null,
        messages
      )

      this.$bvModal.msgBoxOk([message], {
        title: 'Détail du changelog de la version ' + version,
        size: 'xl',
        buttonSize: 'lg',
        okVariant: 'primary',
        okTitle: 'OK',
        cancelTitle: 'Annuler',
        centered: true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Changelog.vue